import React, { useState } from 'react';
import { motion } from 'framer-motion';

// Utility to shuffle options and update answer index
function shuffleQuestionOptions(question) {
  const optionObjs = question.options.map((opt, idx) => ({
    text: opt,
    isCorrect: idx === question.answer
  }));
  for (let i = optionObjs.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [optionObjs[i], optionObjs[j]] = [optionObjs[j], optionObjs[i]];
  }
  const newOptions = optionObjs.map(o => o.text);
  const newAnswer = optionObjs.findIndex(o => o.isCorrect);
  return {
    ...question,
    options: newOptions,
    answer: newAnswer
  };
}

const originalQuestions = [
  {
    question: "I'm not really into football.",
    options: [
      "It's not my cup of tea.",
      "It isn't to my liking tea.",
      "That's why I kick it down."
    ],
    answer: 0,
    level: "B2",
    page: 1
  },
  {
    question: "He was late again. That really __________.",
    options: [
      "got on my nerves",
      "stood on my patience",
      "broke all my feelings"
    ],
    answer: 0,
    level: "B2",
    page: 1
  },
  {
    question: "I'm exhausted. I've been working __________.",
    options: [
      "round the clock",
      "circle and circle",
      "under the moonlight times"
    ],
    answer: 0,
    level: "B2",
    page: 1
  },
  {
    question: "I was so embarrassed, I just wanted the ground to __________.",
    options: [
      "swallow me up",
      "eat my shame",
      "cover my face"
    ],
    answer: 0,
    level: "B2",
    page: 1
  },
  {
    question: "We were talking for hours — we really __________.",
    options: [
      "hit it off",
      "punched the talk",
      "made a connect fastly"
    ],
    answer: 0,
    level: "B2",
    page: 1
  },
  {
    question: "I'm not sure about that idea. Let's just __________ for now.",
    options: [
      "play it by ear",
      "hear it by play",
      "sing it later"
    ],
    answer: 0,
    level: "B2",
    page: 2
  },
  {
    question: "He completely forgot our meeting. It must have __________.",
    options: [
      "slipped his mind",
      "fallen his brain",
      "gone through his ears"
    ],
    answer: 0,
    level: "B2",
    page: 2
  },
  {
    question: "I'm just going to tell her the truth and __________.",
    options: [
      "get it off my chest",
      "drop my emotions",
      "push my heart outside"
    ],
    answer: 0,
    level: "B2",
    page: 2
  },
  {
    question: "I can't afford a holiday right now—I'm __________.",
    options: [
      "broke",
      "out of moneying",
      "empty in pockets"
    ],
    answer: 0,
    level: "B2",
    page: 2
  },
  {
    question: "I didn't get the promotion, but I'm trying to stay positive.",
    options: [
      "Every cloud has a silver lining",
      "Each rain makes a rainbow",
      "There's always some shine in cloud"
    ],
    answer: 0,
    level: "B2",
    page: 2
  },
  {
    question: "I tried to fix the sink, but I only made it worse.",
    options: [
      "I made a dog's breakfast of it",
      "I cooked the pipes badly",
      "It was like a dinner gone cold"
    ],
    answer: 0,
    level: "B2",
    page: 3
  },
  {
    question: "Don't mention his ex. It's still a bit of __________.",
    options: [
      "a sore point",
      "a hurting topic",
      "a soft memory"
    ],
    answer: 0,
    level: "B2",
    page: 3
  },
  {
    question: "I didn't plan the trip at all. I just __________.",
    options: [
      "played it by ear",
      "used my sound plans",
      "listened to my way"
    ],
    answer: 0,
    level: "B2",
    page: 3
  },
  {
    question: "I didn't sleep at all last night. I'm running on __________.",
    options: [
      "fumes",
      "low juice",
      "zero petrol"
    ],
    answer: 0,
    level: "B2",
    page: 3
  },
  {
    question: "He talks a lot, but when it comes to action, he never __________.",
    options: [
      "puts his money where his mouth is",
      "pays the words",
      "speaks with pockets"
    ],
    answer: 0,
    level: "B2",
    page: 3
  },
  {
    question: "She's always changing her mind. She's so __________.",
    options: [
      "indecisive",
      "in two thoughts",
      "not sure all time"
    ],
    answer: 0,
    level: "B2",
    page: 4
  },
  {
    question: "I thought he would be upset, but he just __________.",
    options: [
      "took it in stride",
      "walked it over",
      "caught it cool"
    ],
    answer: 0,
    level: "B2",
    page: 4
  },
  {
    question: "We need to finish this report tonight. We're really __________.",
    options: [
      "up against the clock",
      "behind the ticking",
      "stuck in timing"
    ],
    answer: 0,
    level: "B2",
    page: 4
  },
  {
    question: "She's very talented but always __________.",
    options: [
      "sells herself short",
      "gives small image",
      "does tiny talking"
    ],
    answer: 0,
    level: "B2",
    page: 4
  },
  {
    question: "I didn't enjoy the film. It didn't really __________.",
    options: [
      "live up to the hype",
      "fill the noise",
      "get the sparkle"
    ],
    answer: 0,
    level: "B2",
    page: 4
  },
  {
    question: "They had an argument, but now they've __________.",
    options: [
      "buried the hatchet",
      "hidden the knife",
      "closed the war"
    ],
    answer: 0,
    level: "B2",
    page: 5
  },
  {
    question: "I've explained it three times. Please try to __________.",
    options: [
      "get your head around it",
      "push your brain in",
      "jump the idea"
    ],
    answer: 0,
    level: "B2",
    page: 5
  },
  {
    question: "The event was chaos. Nobody knew who was in charge.",
    options: [
      "It was a free-for-all",
      "All went on freedom",
      "There was too much everyone"
    ],
    answer: 0,
    level: "B2",
    page: 5
  },
  {
    question: "He's a nice guy, but he always tries to __________.",
    options: [
      "steal the spotlight",
      "grab the lamp",
      "hold the shine"
    ],
    answer: 0,
    level: "B2",
    page: 5
  },
  {
    question: "We haven't made a final decision yet. it's still __________.",
    options: [
      "up in the air",
      "high in sky",
      "floating around thought"
    ],
    answer: 0,
    level: "B2",
    page: 5
  }
];

// Shuffle options for each question once at module load
const questions = originalQuestions.map(q => shuffleQuestionOptions(q));

function Quiz({ setScore }) {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOption, setSelectedOption] = useState(null);

  const questionsForCurrentPage = questions.filter(q => q.page === currentPage);
  const totalPages = 5;

  const handleAnswer = (index) => {
    setSelectedOption(index);
    setTimeout(() => {
      const newAnswers = [...answers, index];
      setAnswers(newAnswers);

      if (currentQuestion < questionsForCurrentPage.length - 1) {
        setCurrentQuestion(currentQuestion + 1);
      } else if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
        setCurrentQuestion(0);
      } else {
        const correctAnswers = newAnswers.reduce((acc, answer, idx) => {
          return acc + (answer === questions[idx].answer ? 1 : 0);
        }, 0);
        setScore(correctAnswers);
      }
      setSelectedOption(null);
    }, 500); // Delay to show selection animation
  };

  const handleBack = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
      setAnswers(answers.slice(0, -1));
    } else if (currentPage > 1) {
      const previousPageQuestions = questions.filter(q => q.page === currentPage - 1);
      setCurrentPage(currentPage - 1);
      setCurrentQuestion(previousPageQuestions.length - 1);
      setAnswers(answers.slice(0, -1));
    }
    setSelectedOption(null);
  };

  const progress = ((currentPage - 1) * 5 + (currentQuestion + 1)) / (totalPages * 5) * 100;
  const canGoBack = currentQuestion > 0 || currentPage > 1;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative max-w-2xl mx-auto"
    >
      {/* Decorative elements */}
      <div className="absolute -top-20 -left-20 w-40 h-40 bg-[#F0F7FF] rounded-full blur-3xl opacity-30"></div>
      <div className="absolute top-1/2 -right-12 w-24 h-24 bg-[#F0F7FF] rounded-full blur-2xl opacity-40"></div>
      <div className="absolute -bottom-20 left-1/3 w-32 h-32 bg-[#F0F7FF] rounded-full blur-2xl opacity-30"></div>
      
      <div className="relative backdrop-blur-sm bg-white/80 rounded-3xl shadow-[0_8px_32px_0_rgba(31,38,135,0.1)] border border-white/30 p-8 pb-20 overflow-hidden">
        {/* Subtle gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-transparent pointer-events-none"></div>
        
        <div className="relative z-10">
          <div className="mb-8">
            <div className="flex justify-between text-sm mb-3">
              <span className="font-medium text-gray-700">Question {(currentPage - 1) * 5 + currentQuestion + 1} of {questions.length}</span>
              <span className="font-medium text-[#2563EB]">{Math.round(progress)}% Complete</span>
            </div>
            <div className="h-2 bg-[#F0F7FF] rounded-full overflow-hidden">
              <motion.div
                className="h-full bg-[#2563EB] rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.5 }}
              />
            </div>
          </div>

          <motion.div
            key={`${currentPage}-${currentQuestion}`}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
            className="mb-8"
          >
            <h2 className="text-2xl font-semibold text-gray-800 mb-8">
              {questionsForCurrentPage[currentQuestion].question}
            </h2>

            <div className="space-y-4">
              {questionsForCurrentPage[currentQuestion].options.map((option, index) => (
                <motion.button
                  key={index}
                  onClick={() => handleAnswer(index)}
                  className={`w-full p-6 text-left rounded-2xl transition-all duration-200
                    ${selectedOption === index 
                      ? 'bg-[#2563EB] text-white shadow-lg transform scale-[0.98] border-none' 
                      : 'bg-white hover:bg-[#F0F7FF] border border-gray-100 hover:border-[#2563EB]/30'
                    }
                    shadow-[0_4px_20px_0_rgba(31,38,135,0.07)]
                    group relative overflow-hidden
                  `}
                  whileHover={{ scale: 1.01 }}
                  whileTap={{ scale: 0.98 }}
                  transition={{ type: "spring", stiffness: 300, damping: 17 }}
                >
                  {/* Hover effect overlay */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                  
                  <span className={`block font-medium text-lg
                    ${selectedOption === index 
                      ? 'text-white' 
                      : 'text-gray-700 group-hover:text-gray-900'
                    }
                  `}>
                    {option}
                  </span>
                </motion.button>
              ))}
            </div>
          </motion.div>
        </div>

        {/* Back Button */}
        {canGoBack && (
          <motion.button
            onClick={handleBack}
            className="absolute left-8 bottom-8 flex items-center justify-center w-10 h-10 rounded-full bg-white border border-gray-100 hover:border-[#2563EB]/30 shadow-[0_4px_20px_0_rgba(31,38,135,0.07)] group transition-all duration-200"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 17 }}
          >
            <svg
              className="w-5 h-5 text-gray-600 group-hover:text-[#2563EB] transition-colors"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M15 19l-7-7 7-7" />
            </svg>
          </motion.button>
        )}
      </div>
    </motion.div>
  );
}

export default Quiz; 